/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
import { classNames } from 'shared/lib/classNames/classNames';
import React, { useEffect, useRef, useState } from 'react';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { useApi } from 'app/api/APIProvider';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import Approved from 'shared/assets/icons/approved.svg';
import { servicesActions } from 'features/Services';
import { useDispatch } from 'react-redux';
import CardPlug from 'shared/assets/img/pages/card-plug.png';
import { PageLoader } from 'shared/ui/PageLoader/PageLoader';
import cls from './PolicyBanner.module.scss';

interface IBanner {
    name: string,
    description: string,
    img: string,
    button: {
        text: string,
        url?: string,
        boughtText?: string,
    },
    cost?: string,
    unique_key?: string,
    type: string,
}

interface PolicyBannerProps {
    banner: IBanner,
    isPaid?: boolean,
    callback?: () => void,
}

export const PolicyBanner = ({ banner, isPaid, callback }: PolicyBannerProps) => {
    const api = useApi();
    const dispatch = useDispatch();
    const [isBought, setIsBought] = useState(isPaid);
    const { name, description, img, cost, button, unique_key, type } = banner;
    const { text, url, boughtText } = button;

    const cancelProduct = async () => {
        await api.CancelFinance({productKey: unique_key});
        setIsBought(false);
        dispatch(servicesActions.changeStatusInfo({ key: unique_key, status: false }));
        callback();
    };

    const scrollToBottom = () =>{
        const element = document.querySelector('#form');
        element.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        setIsBought(isPaid);
    }, [isPaid]);

    return (
        <div className={classNames(cls.banner, { [cls.hasBackgroundImage]: unique_key === 'nsj' })}>
            <div className={cls.leftSide}>
                <div className={cls.title}>
                    <Title className={cls.name} color="#353850" size={TitleSize.title_36}>
                        {name}
                    </Title>
                    <Text className={cls.description} color="#353850" size={TextSize.text_16}>
                        {description}
                    </Text>
                </div>
                <div className={classNames(`${cls.imgBox} ${cls.mobImgBox}`, { [cls.hidden]: unique_key === 'nsj' })}>
                    <img src={img} className={cls.img} alt="Разумные деньги фото №4" />
                </div>
                <AppLink to={url} className={classNames(cls.linkButton, { [cls.disabled]: type === 'credit' })}>
                    <Button className={cls.button} theme={ButtonTheme.PRIMARY} >
                        {text}
                    </Button>
                </AppLink>
                <div className={classNames('', { [cls.disabled]: type === 'banner' })}>
                    <div className={classNames(cls.buttonWrapper, { [cls.disabled]: isBought })}>
                        <Button type="submit" className={cls.button} theme={ButtonTheme.PRIMARY} onClick={() => scrollToBottom()}>
                            {text}
                        </Button>
                        <Text className={cls.description} color="#000" size={TextSize.text_14}>{cost}</Text>
                    </div>
                    <div className={classNames(cls.buttonWrapper, { [cls.disabled]: !isBought })}>
                        <Button className={cls.button} icon={<Approved />} theme={ButtonTheme.PRIMARY}>
                            {boughtText}
                        </Button>
                        <Button type="submit" className={classNames(cls.denialButton, { [cls.disabled]: unique_key === 'credit10' })} theme={ButtonTheme.PRIMARY} onClick={cancelProduct}>
                            Отказаться
                        </Button>
                    </div>
                </div>
            </div>
            <div className={classNames(`${cls.rightSide} ${cls.imgBox}`, { [cls.hidden]: unique_key === 'nsj' })}>
                <img src={img} className={cls.img} alt="Разумные деньги фото №5" />
            </div>
        </div>
    );
};

